import './App.css';
import PortfolioCard from './Components/PortfolioCard';
function App() {
  return (
    <div className='App'>
      <PortfolioCard/>
    </div>
  );
}

export default App;
